let defaultModule = {
    id: null,
    course_id: null,
    title: '',
    description: null,
    order: null,
    is_active: false,
    created_at: null,
    updated_at: null
};

export default defaultModule;

